angular.module('unergie.main')
.controller('metricsCtrl', ($scope, $state, $interval, ApiAdmin, BoFeaturesService, ErrorCatcher) => {
    $scope.currentDashboard = null
    $scope.dashboardNames = []
    $scope.dashboards = {}
    $scope.currentElements = []
    ApiAdmin.metricDashboards().$promise.then((dashboards) => {
        // clear dashboards
        $scope.dashboards = {}
        $scope.dashboardNames = []
        const propertyNames = Object.getOwnPropertyNames(dashboards)
        propertyNames.forEach((name) => {
            if (Array.isArray(dashboards[name])) {
                // rework content to split lines and add spacers
                $scope.dashboards[name] = []
                let currentLineIdx = -1
                let currentLine
                let currentPos = 0
                dashboards[name].forEach((item) => {
                    if (item.y !== currentLineIdx) {
                        currentLine = []
                        $scope.dashboards[name].push(currentLine)
                        currentLineIdx = item.y
                        currentPos = 0
                    }
                    if (currentPos !== item.x) {
                        currentLine.push({
                            type: 'spacer',
                            x: currentPos,
                            y: currentLineIdx,
                            width: item.x - currentPos,
                            height: item.height,
                        })
                    }
                    currentLine.push(item)
                    currentPos = item.x + item.width
                })

                // add dashboard to list
                $scope.dashboardNames.push(name)
            }
        })

        if ($scope.dashboardNames.length) {
            [$scope.currentDashboard] = $scope.dashboardNames
            $scope.refreshImages()
            $scope.dashboardSelected()
        }
    })


    $scope.dashboardSelected = () => {
        $scope.currentElements = $scope.dashboards[$scope.currentDashboard]
        console.log('selected !', $scope.currentDashboard, $scope.currentElements)
    }

    $scope.refreshImages = () => {
        const ts = Date.now()
        $scope.dashboardNames.forEach((name) => {
            $scope.dashboards[name].forEach((line) => {
                line.forEach((item) => {
                    // create unique urls for images
                    if (item.type === 'image') {
                        item.src = `${item.url}?ts=${ts}`
                    }
                })
            })
        })
    }
})
